export default "__VITE_ASSET__TPH7Xjqp__"